import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Gift = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="gift icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.77358 1C5.61187 1 4.65192 1.39914 3.98138 2.07909C3.32116 2.74857 3 3.63196 3 4.5C3 5.01022 3.11096 5.52573 3.3365 6H2C0.895431 6 0 6.89543 0 8L0 9C0 10.1046 0.89543 11 2 11H11V6H11.846C11.6626 5.17198 11.325 4.20175 10.7732 3.33703C9.98991 2.10974 8.70003 1 6.77358 1ZM12.154 6H13V11H22C23.1046 11 24 10.1046 24 9V8C24 6.89543 23.1046 6 22 6H20.6635C20.889 5.52573 21 5.01022 21 4.5C21 3.63196 20.6788 2.74857 20.0186 2.07909C19.3481 1.39914 18.3881 1 17.2264 1C15.3 1 14.0101 2.10974 13.2268 3.33703C12.675 4.20175 12.3374 5.17198 12.154 6ZM11 13H2V22C2 23.1046 2.89543 24 4 24H11V13ZM13 24H20C21.1046 24 22 23.1046 22 22V13H13V24ZM18.5946 5.51659C18.3406 5.77414 17.9138 6 17.2264 6H14.2168C14.3686 5.47309 14.5961 4.90924 14.9128 4.41297C15.4591 3.55693 16.1944 3 17.2264 3C17.9138 3 18.3406 3.22586 18.5946 3.48341C18.8589 3.75143 19 4.11804 19 4.5C19 4.88196 18.8589 5.24857 18.5946 5.51659ZM9.78323 6C9.63143 5.47309 9.40394 4.90924 9.08722 4.41297C8.54091 3.55693 7.80563 3 6.77358 3C6.08624 3 5.6594 3.22586 5.40541 3.48341C5.1411 3.75143 5 4.11804 5 4.5C5 4.88196 5.1411 5.24857 5.40541 5.51659C5.6594 5.77414 6.08624 6 6.77358 6H9.78323Z"
    />
  </svg>
)
